import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const ProgressStepsList = styled.ol`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${theme.space[12]};
    width: fit-content;
    margin: 0;
    padding: ${theme.space[4]};
    list-style: none;

    > li {
        position: relative;
    }

    &::before {
        position: absolute;
        inset: 0 auto 0 0;
        width: ${theme.sizes[32]};
        border-radius: ${theme.radii[16]};
        background-color: ${theme.colors.background.inset};
        content: '';
    }
`;
